import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import closeIcon from '@/pages/aigc/assets/svg/close.svg';
import './index.scss';

interface IVideoPreviewProps {
  visible?: boolean;
  title?: string;
  onClose?: () => void;
  children?: React.ReactNode;
}

const VideoPreview: React.FC<IVideoPreviewProps> = ({
  visible = false,
  title = '',
  onClose,
  children,
}) => {
  const [internalVisible, setInternalVisible] = useState<boolean>(visible);
  const effectiveVisible = useMemo(() => internalVisible, [internalVisible]);

  // 同步外部visible状态
  useEffect(() => {
    setInternalVisible(visible);
  }, [visible]);

  const handleClosePreview = useCallback(() => {
    setInternalVisible(false);
    onClose?.();
  }, [onClose]);

  useEffect(() => {
    if (!effectiveVisible) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleClosePreview();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('dba-video-preview-blur-background');
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
      document.body.classList.remove('dba-video-preview-blur-background');
    };
  }, [effectiveVisible, handleClosePreview]);

  // 渲染预览层到 body 的 Portal 组件
  const renderPreviewOverlay = () => {
    if (!effectiveVisible) return null;

    return createPortal(
      <div className="dba-video-preview-overlay">
        <div className="dba-video-preview-header">
          <div className="dba-video-preview-title" title={title}>
            {title || ''}
          </div>
          <div className="dba-video-preview-actions">
            <img
              className="dba-video-preview-action-btn"
              src={closeIcon}
              onClick={handleClosePreview}
              alt="close"
            />
          </div>
        </div>
        <div className="dba-video-preview-content">
          {children}
        </div>
      </div>,
      document.body,
    );
  };

  return renderPreviewOverlay();
};

export default VideoPreview;
